import { render, staticRenderFns } from "./CreateVacancies.vue?vue&type=template&id=bde86b06&scoped=true&"
import script from "./CreateVacancies.vue?vue&type=script&lang=js&"
export * from "./CreateVacancies.vue?vue&type=script&lang=js&"
import style0 from "./CreateVacancies.vue?vue&type=style&index=0&id=bde86b06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde86b06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
